import { createBrowserRouter } from "react-router-dom";
import { Layout } from "@components/layout/Layout";
import {
  HomePage,
  AboutPage,
  ProductsPage,
  FaqPage,
  ContactPage,
  NotFoundPage,
} from "@pages/index";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Layout />,
      children: [
        { index: true, element: <HomePage /> },
        { path: "nosotros", element: <AboutPage /> },
        { path: "productos", element: <ProductsPage /> },
        { path: "faq", element: <FaqPage /> },
        { path: "contacto", element: <ContactPage /> },
        { path: "*", element: <NotFoundPage /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);
